import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { KycDocumentsResponse } from './types/Kyc';

export default (makeCall: MakeCall) =>
  (userId: 'me' | number, kycUuid: string) =>
    makeCall<KycDocumentsResponse>(
      'GET',
      `/api/v2/user/${userId}/kyc/${kycUuid}/documents`,
    );
